import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useApiFormAuthPasswordRecover } from '../../../../api-new/state/auth'
import { useLoad } from '../../../../shared/hooks/load'
import { useQueryParam } from '../../../../shared/hooks/location'
import { authPath } from '../hooks/auth-path'
import { AuthHead, AuthNotice, AuthPage } from '../../../../shared/sso-workspace/auth-card'

// /auth/password-recover/request: email a link to set or reset a password.
// Also where "Set a password" goes for people who have only ever signed in
// with single sign-on; ?email= prefills the field.
export const PasswordRequest = () => {
  const history = useHistory()

  const apiFormAuthPasswordRecover = useApiFormAuthPasswordRecover()

  const [email, updateEmail] = useState(useQueryParam('email') || '')
  const [sending, updateSending] = useState(false)
  const [failed, updateFailed] = useState(false)

  useLoad(() => apiFormAuthPasswordRecover.init(), [])

  const handleSubmit = async e => {
    e.preventDefault()

    const value = email.trim()

    if (!value) {
      return
    }

    updateSending(true)
    updateFailed(false)

    try {
      await apiFormAuthPasswordRecover.get(`${value}`)
      history.replace(`/auth/password-recover/result/${value}`)
    } catch {
      updateFailed(true)
    } finally {
      updateSending(false)
    }
  }

  return (
    <AuthPage labelledBy="password-request-title">
      <AuthHead
        id="password-request-title"
        title="Set or reset your password"
        lede="Enter the email address you sign in with. We'll email you a link to choose a new password."
      />

      {failed &&
        <AuthNotice tone="bad" role="alert">
          <p>We couldn't send the email. Check the address and try again.</p>
        </AuthNotice>}

      <form className="sa-form" noValidate onSubmit={handleSubmit}>
        <div className="sw-field">
          <label className="sw-label" htmlFor="recover-email">Email</label>
          <input
            id="recover-email"
            name="email"
            className="form-control"
            type="email"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            placeholder="name@example.org"
            autoFocus
            value={email}
            onChange={e => updateEmail(e.target.value)}
          />
        </div>

        <button type="submit" className="btn sw-btn-primary sa-block" disabled={!email.trim() || sending}>
          {sending ? 'Sending…' : 'Email me a link'}
        </button>
      </form>

      <p className="sa-foot">
        <Link replace to={authPath('/auth/email', { email: email.trim() })}>Back to sign in</Link>
      </p>
    </AuthPage>
  )
}
